module.exports = __webpack_public_path__ + "img/sc-4p-2022-2.a0c71376.png";